<template>
  <div class="breadcont">
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item, index)  in levelList" :key="item.path" v-if="item.meta.title">
          <span v-if="item.redirect === 'noredirect' || index == levelList.length - 1" class="no-redirect">{{
            item.meta.title }}</span>
          <router-link v-else :to="item.redirect || item.path">{{ item.meta.title }}</router-link>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
    <div v-if="isShowCollect" class="collectdiv">
      <div style="cursor: pointer; padding:0 15px;" @click="handleConfirmDuihuanClass"><svg-icon icon-class="duihuan-pre"
          v-if="isDuihuan == false"></svg-icon>
        <svg-icon icon-class="duihuan-suc" v-if="isDuihuan == true"></svg-icon>
        兑换课程
      </div>
      <div style="text-align: center;  padding:0 15px; cursor: pointer;" @click="handleConfirmCollectClass">
        <i class="el-icon-star-off" v-if="isCollects == false"></i>
        <i class="el-icon-star-on" v-if="isCollects == true"></i>

        <!-- <i class="el-icon-star-off"></i>
        <i class="el-icon-star-on"></i> -->
        收藏课程
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="30%" center>
      <el-form size="mini">
        <el-form-item label="课程名称：">
          {{ classTitle }}
        </el-form-item>
        <el-form-item label="所需钻石：">
          10
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" style="background: #ffdb58;" @click="confirmDuihuan">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import request from '@/utils/request.js'
export default {
  props: {

  },
  computed: {
    ...mapGetters(['classID', 'isCollects', 'classType', 'classTitle', 'isDuihuan']),
  },
  created() {
    this.getBreadcrumb()
    console.log(this.diamond)
  },
  data() {
    return {
      levelList: null,
      isShowCollect: false,
      dialogVisible: false
    }
  },

  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    ...mapMutations(['changeCollectStatus', 'changeDuiHuanStatus']),
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      console.log('matcher')
      console.log(matched)
      if (matched[1].name == "sourceDetail" || matched[1].name == 'classDetail') {
        this.isShowCollect = true
      } else {
        this.isShowCollect = false
      }
      const first = matched[0]
      if (first && first.name !== 'home') {
        // matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
        matched = matched
      }
      this.levelList = matched
    },
    // 收藏课程
    handleConfirmDuihuanClass() {
      this.dialogVisible = true;


      console.log(this.classID)
    },
    // 确认兑换
    confirmDuihuan() {
      request({
        url: '/admin/collect/add',
        method: 'post',
        data: {
          courseware_id: this.classID,
          type: this.classType
        }
      }).then(res => {
        console.log(res)

        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '兑换成功'
          })
          this.changeDuiHuanStatus(true)
        }

      }).catch(err => {
        this.dialogVisible = false;
      })
    },
    // 确认收藏
    handleConfirmCollectClass() {
      request({
        url: '/admin/shoucang/add',
        method: 'post',
        data: {
          courseware_id: this.classID,
          type: this.classType
        }
      }).then(res => {
        console.log(res)
        console.log('1111111111')

        if (res.code == 200 && res.message == '收藏成功') {
          this.$message({
            type: 'success',
            message: '收藏成功'
          })
          this.changeCollectStatus(true)
        } else if (res.code == 200 && res.message == '已收取消收藏') {
          this.$message({
            type: 'success',
            message: '您已收取消收藏'
          })
          this.changeCollectStatus(false)
        }

      }).catch(err => {
        console.log(err)
        this.$message({
          type: 'success',
          message: '收藏失败'
        })


      })
    },

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.breadcont {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-breadcrumb.el-breadcrumb {
  width: 50%;
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}

.collectdiv {
  width: 20%;
  display: flex;
  font-size: 14px;
  color: #000000;
  justify-content: space-between;
  align-items: center;

  i {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue